<template>
  <AnalyticsTemplate 
    page-title="流量统计"
    chart-type="traffic"
  />
</template>

<script>
import AnalyticsTemplate from './AnalyticsTemplate.vue'

export default {
  name: 'TrafficAnalytics',
  components: {
    AnalyticsTemplate
  }
}
</script>
